export default function webRtcAudio(
  $rootScope,
  $log,
  $q,
  XucPhoneEventListener,
  XucPhoneState,
  XucVideoEventManager,
  JitsiProxy
) {
  var getUserRingtone = () => {
    const data = localStorage.getItem("user_ringtone");
    return data ? JSON.parse(data).file : "incoming_call.mp3";
  };

  var getSecondaryRingingDeviceId = () => {
    return window.localStorage.getItem("SecondaryRingingDeviceId") || "null";
  };

  var secondaryRingingDeviceActivated = () => {
    return (
      getSecondaryRingingDeviceId() != "null" &&
      getSecondaryRingingDeviceId() != getOuputDeviceId()
    );
  };

  var getOuputDeviceId = () => {
    return window.localStorage.getItem("AudioOutputDeviceId") || "default";
  };

  const getAudioElements = () => {
    return {
      ringing: {
        id: "webrtc_audio_ringing",
        src: "assets/audio/pratix/ringing.mp3",
      },
      incomingCall: {
        id: "webrtc_audio_incoming_call",
        src: `assets/audio/pratix/${getUserRingtone()}`,
      },
      incomingCallSecondary: {
        id: "webrtc_audio_incoming_call_secondary",
        src: `assets/audio/pratix/${getUserRingtone()}`,
      },
      incomingSecondCall: {
        id: "webrtc_audio_incoming_second_call",
        src: "assets/audio/pratix/incoming_second_call.mp3",
      },
      incomingSecondCallSecondary: {
        id: "webrtc_audio_incoming_second_call_secondary",
        src: "assets/audio/pratix/incoming_second_call.mp3",
      },
      hangupCall: {
        id: "webrtc_audio_hangup_call",
        src: "assets/audio/pratix/hangup_call.mp3",
      },
    };
  };

  var _setAudioElemSinkId = (audioElem, sinkId) => {
    if (!audioElem.setSinkId) {
      return $q.reject("Browser doesn't support changing audio output");
    }
    return Promise.resolve(audioElem.setSinkId(sinkId)).catch((err) => {
      $log.debug(err + ". Using default ringing device instead");
      return $q.reject(err);
    });
  };

  const _createOrUpdateAudioElement = (audioConfig) => {
    let audioElement = document.getElementById(audioConfig.id);
    if (!audioElement) {
      audioElement = document.createElement("audio");
      audioElement.id = audioConfig.id;
      audioElement.preload = "auto";
      audioElement.loop = audioConfig.id !== "webrtc_audio_hangup_call";
      angular.element(document.body).append(audioElement);
      audioElement.src = audioConfig.src;
    }

    return audioElement;
  };

  _createOrUpdateAudioElement(getAudioElements().ringing);
  _createOrUpdateAudioElement(getAudioElements().incomingCall);
  _createOrUpdateAudioElement(getAudioElements().incomingSecondCall);
  _createOrUpdateAudioElement(getAudioElements().hangupCall);
  let secondaryDeviceId = getSecondaryRingingDeviceId();
  if (secondaryDeviceId != "null") {
    _createOrUpdateAudioElement(getAudioElements().incomingCallSecondary);
    _createOrUpdateAudioElement(getAudioElements().incomingSecondCallSecondary);
  }

  var isEnabled = false;
  var incomingCallAudio = null;
  var incomingSecondCallAudio = null;
  var incomingCallAudioSecondary = null;
  var incomingSecondCallAudioSecondary = null;

  var ringingAudio = null;
  var hangupCallAudio = null;
  var remoteMediaAddedHandlerUnsubscribe = null;

  var playPromise;

  var startAudio = function (element) {
    element.currentTime = 0;
    playPromise = element.play();
  };

  var stopAudio = function (element) {
    if (playPromise !== undefined) {
      playPromise
        .then(function () {
          stopAudioImpl(element);
        })
        .catch(function () {
          stopAudioImpl(element);
        });
    } else {
      stopAudioImpl(element);
    }
  };

  var stopAudioImpl = function (element) {
    element.pause();
    element.currentTime = 0;
    playPromise = undefined;
  };

  var isOriginate = function (event) {
    return (
      event && event.userData && event.userData.XUC_CALLTYPE == "Originate"
    );
  };

  var onPhoneEvent = function (event) {
    if (!isEnabled) {
      return;
    }

    switch (event.eventType) {
    case "EventDialing":
      stopAudio(incomingCallAudio);
      if (isOriginate(event)) stopAudio(ringingAudio);
      else startAudio(ringingAudio);
      break;
    case "EventRinging":
      _startRinging();
      break;
    case "EventReleased":
      startAudio(hangupCallAudio);
      stopRingtones();
      break;
    default:
      stopRingtones();
    }
  };

  var stopRingtones = function () {
    stopAudio(ringingAudio);
    stopAudio(incomingCallAudio);
    stopAudio(incomingSecondCallAudio);
    if (secondaryRingingDeviceActivated()) {
      stopAudio(incomingCallAudioSecondary);
      stopAudio(incomingSecondCallAudioSecondary);
    }
  };

  var enable = function () {
    isEnabled = true;
    if (remoteMediaAddedHandlerUnsubscribe === null) {
      remoteMediaAddedHandlerUnsubscribe = _addHandleRemoteMediaAdded();
    }
  };

  var disable = function () {
    if (isEnabled) {
      stopRingtones();
      isEnabled = false;
      remoteMediaAddedHandlerUnsubscribe();
      remoteMediaAddedHandlerUnsubscribe = null;
    }
  };

  var init = function () {
    var _findElem = function (elem) {
      return document.getElementById(elem);
    };
    ringingAudio = _findElem("webrtc_audio_ringing");
    incomingCallAudio = _findElem("webrtc_audio_incoming_call");
    incomingSecondCallAudio = _findElem("webrtc_audio_incoming_second_call");
    hangupCallAudio = _findElem("webrtc_audio_hangup_call");

    incomingCallAudioSecondary = _findElem(
      "webrtc_audio_incoming_call_secondary"
    );
    incomingSecondCallAudioSecondary = _findElem(
      "webrtc_audio_incoming_second_call_secondary"
    );

    if (
      !ringingAudio ||
      !incomingCallAudio ||
      !incomingSecondCallAudio ||
      !hangupCallAudio
    ) {
      $log.error("Unable to inject audio elements");
    }
    if (
      secondaryRingingDeviceActivated() &&
      (!incomingCallAudioSecondary || !incomingSecondCallAudioSecondary)
    ) {
      $log.error("Unable to inject secondary audio elements");
    }
    XucPhoneEventListener.addHandlerCustom(onPhoneEvent);
    _changeRingingDevice(getOuputDeviceId(), true);
    _changeRingingDevice(getSecondaryRingingDeviceId());

    XucVideoEventManager.subscribeToVideoInviteEvent($rootScope, _startRinging);
  };

  var _addHandleRemoteMediaAdded = () => {
    return xc_webrtc.setHandler(
      xc_webrtc.MessageType.INCOMING,
      function (event) {
        if (event.type === xc_webrtc.Incoming.REMOTE_MEDIA_ADDED) {
          stopRingtones();
        }
      }
    );
  };

  var _changeRingtone = ({ file }) => {
    [incomingCallAudio, ...(getSecondaryRingingDeviceId() !== "null" ? [incomingCallAudioSecondary] : [])]
      .forEach(audio => audio.src = `assets/audio/pratix/${file}`);
  };


  var _handleSecondaryAudioTag = () => {
    const secondaryRingingDeviceId = getSecondaryRingingDeviceId();
    const audioOutputDeviceId = getOuputDeviceId();
    const shouldRemove =
      secondaryRingingDeviceId === audioOutputDeviceId || secondaryRingingDeviceId === "null";

    const updateAudioElement = (audio, config) => {
      if (shouldRemove) {
        if (audio) audio.remove();
        return null;
      }
      const audioElem = _createOrUpdateAudioElement(config);
      _setAudioElemSinkId(audioElem, secondaryRingingDeviceId).catch($log.debug);
      return audioElem;
    };

    incomingCallAudioSecondary = updateAudioElement(
      incomingCallAudioSecondary,
      getAudioElements().incomingCallSecondary
    );

    incomingSecondCallAudioSecondary = updateAudioElement(
      incomingSecondCallAudioSecondary,
      getAudioElements().incomingSecondCallSecondary
    );
  };

  var _changeRingingDevice = (id, primary=false) => {
    _handleSecondaryAudioTag();
    if (primary) {
      return $q.all([
        _setAudioElemSinkId(incomingCallAudio, id),
        _setAudioElemSinkId(incomingSecondCallAudio, id),
        _setAudioElemSinkId(ringingAudio, id),
        _setAudioElemSinkId(hangupCallAudio, id),
      ])
        .then(() => $log.debug('Audio elements updated successfully'))
        .catch((err) => $log.debug('Error updating audio elements:', err));
    }
  };

  var _isBusy = () => {
    return (
      XucPhoneState.isPhoneOffHook(XucPhoneState.getState()) ||
      JitsiProxy.videoIsOngoing()
    );
  };

  var _startRinging = () => {
    _isBusy()
      ? startAudio(incomingSecondCallAudio)
      : startAudio(incomingCallAudio);
    if (secondaryRingingDeviceActivated()) {
      _isBusy()
        ? startAudio(incomingSecondCallAudioSecondary)
        : startAudio(incomingCallAudioSecondary);
    }
    stopAudio(ringingAudio);
  };

  init();

  return {
    enable: function () {
      enable();
    },
    disable: function () {
      disable();
    },
    isEnabled: function () {
      return isEnabled;
    },
    setAudioElemSinkId: _setAudioElemSinkId,
    changeRingingDevice: _changeRingingDevice,
    handleSecondaryAudioTag: _handleSecondaryAudioTag,
    createOrUpdateAudioElement: _createOrUpdateAudioElement,
    changeRingtone: _changeRingtone,
    startRinging: _startRinging,
    stopRingtones: function () {
      stopRingtones();
    },
  };
}
